import React from 'react';
import { useTranslation } from 'react-i18next';

const InviteUserForm = ({
  email,
  onChange,
  onSubmit,
  error,
  success,
  submitting = false,
  submitLabel,
  disabled = false,
  capLabel = null,
  disabledMessage = null
}) => {
  const { t } = useTranslation('company');

  return (
    <div className="card invite-card">
      <h2>{t('inviteTitle')}</h2>
      <p className="invite-description">
        {t('inviteDescription')}
      </p>
      {capLabel && <p className="invite-cap-label">{capLabel}</p>}
      {disabledMessage && <div className="error">{disabledMessage}</div>}
      {error && <div className="error">{error}</div>}
      {success && <div className="success">{success}</div>}
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="invite-email">{t('inviteEmailLabel')}</label>
          <input
            id="invite-email"
            type="email"
            name="email"
            value={email}
            onChange={onChange}
            required
            disabled={disabled}
            placeholder={t('inviteEmailPlaceholder')}
          />
        </div>
        <div className="modal-actions">
          <button type="submit" className="btn btn-primary" disabled={submitting || disabled}>
            {submitting ? t('sendingInvitation') : (submitLabel || t('sendInvitation'))}
          </button>
        </div>
      </form>
    </div>
  );
};

export default InviteUserForm;
